import "core-js/modules/es.array.concat.js";
import { getReq, postReq, putReq } from './axios';
import { externalCreditBody } from './models';
var BASE_URL = "".concat(apiUrl, "/external-credit");
export var getAllExternalCredits = function getAllExternalCredits() {
  return getReq(BASE_URL);
};
export var getExternalCredit = function getExternalCredit(id) {
  return getReq("".concat(BASE_URL, "/").concat(id));
};
export var createExternalCredit = function createExternalCredit(body) {
  return postReq(BASE_URL, body);
};
export var updateExternalCredit = function updateExternalCredit(id, body) {
  return putReq("".concat(BASE_URL, "/").concat(id), externalCreditBody(body));
};